import FormSelect from './FormSelect'
import { mapGetters } from 'vuex'
import {
  getDegrees
} from '@/api'
export default {
  extends: FormSelect,
  props: {
    config: {
      type: Object,
      default: () => ({
        multiple: false,
      }),
    },
  },
  data () {
    return {
      isOpen: false,
      isLoading: false,
      options: [],
      optionsLoaded: false,
    }
  },
  computed: {
    ...mapGetters([ 'school' ]),
    mergedConfig () {
      return {
        multiple: false,
        searchable: true,
        options: [],
        ...this.config,
      }
    },
    normalizedOptions () {
      // NOTE: we only want to sort the options loaded in from the BE
      // Any user defined options should retain the sort order in which they were entered
      const optionsArray = Object.values(this.options).map(el => el.displayName || el.description).sort()
      const optionsWithHardCodedOptions = optionsArray.filter(Boolean).concat(this.mergedConfig.options || [])
      // ensuring options are unique and sorting the resulting array
      return [ ...new Set(optionsWithHardCodedOptions) ]
    },
  },
  watch: {
    isOpen: {
      async handler (val) {
        if (val && !this.optionsLoaded) {
          this.isLoading = true
          const data = await getDegrees({ school: this.school, returnFields: [ '_id', 'description', 'displayName' ] }) || {}
          this.options = data
          this.optionsLoaded = true
          this.isLoading = false

        }
      },
    },
  },
  methods: {

  },
}
